import React from "react";
import "../styles/ClaimResult.css";

const VoteEvidenceCard = ({
  bill_name,
  vote,
  vote_consistency,
  bill_stance_reason,
  date,
  house,
  url,
  context,
}) => {
  const tags = [`Voted: ${vote}`, house, context];
  return (
    <div className="speech-card">
      <div className="speech-card-header">
        <a href={url} target="_blank" rel="noopener noreferrer">
          <h4 className="speech-card-title">{bill_name}</h4>
        </a>
        {vote_consistency && (
          <div
            className={`verdict-pill ${
              // Directly determine and add the verdict-specific class
              vote_consistency === "consistent"
                ? "verdict-pill-valid"
                : vote_consistency === "inconsistent"
                ? "verdict-pill-invalid"
                : "verdict-pill-ambiguous" // Fallback for 'cannot determine', 'not directly relevant', etc.
            }`}
          >
            {vote_consistency === "consistent"
              ? `✅ Valid`
              : vote_consistency === "inconsistent"
              ? `❎ Invalid`
              : `❓ Ambiguous`}
          </div>
        )}
      </div>

      <p className="speech-quote">“{bill_stance_reason}”</p>

      <div className="speech-card-meta">
        <div className="speech-tags">
          {tags.map((tag, index) => (
            <span key={index} className="speech-tag">
              {tag}
            </span>
          ))}
        </div>
        <div className="speech-meta-info">
          <span>{house}</span> · <span>{date}</span>
        </div>
      </div>
    </div>
  );
};

export default VoteEvidenceCard;
